import { render, staticRenderFns } from "./BusinessUnitEdit.vue?vue&type=template&id=00c2c263&scoped=true"
import script from "./BusinessUnitEdit.vue?vue&type=script&lang=js"
export * from "./BusinessUnitEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c2c263",
  null
  
)

export default component.exports